const WEB_API_PREFIX = '/api/v2';
const EXTERNAL_API_PREFIX = '/external-api/v3';
// What `shortRoute` puts in front of an external API route in place of its prefix.
const EXTERNAL_MARK = /^v3(?:\s+|$)/i;

function withoutPrefix(route: string, prefix: string): string | null {
    if (route !== prefix && !route.startsWith(`${prefix}/`)) return null;
    return route.slice(prefix.length) || '/';
}

/** True for `/api`, `/api/...`, and likewise `/external-api`, but not `/api-keys`. */
function underMount(route: string, mount: string): boolean {
    return route === mount || route.startsWith(`${mount}/`);
}

/**
 * Every route template starts with the API's global prefix, which says nothing on this
 * page. The versioned strings were never seen in a live row, so anything else shows as
 * it is rather than guessed at.
 */
export function shortRoute(route: string): string {
    const webRoute = withoutPrefix(route, WEB_API_PREFIX);
    if (webRoute !== null) return webRoute;
    const externalRoute = withoutPrefix(route, EXTERNAL_API_PREFIX);
    return externalRoute === null ? route : `v3 ${externalRoute}`;
}

function withLeadingSlash(path: string): string {
    return path.startsWith('/') ? path : `/${path}`;
}

/**
 * The stored prefix a "route starts with" filter matches, from the route as the table
 * shows it: "/user" asks for "/api/v2/user" and "v3 /fish" for "/external-api/v3/fish".
 * A stored route typed in full (the details dialog's own filter sends one) is kept, as
 * is anything under `/api` or `/external-api` that `shortRoute` would show as it is.
 */
export function storedRoutePrefix(typed: string): string {
    if (underMount(typed, '/api') || underMount(typed, '/external-api')) return typed;
    const external = EXTERNAL_MARK.exec(typed);
    if (external !== null) {
        const rest = typed.slice(external[0].length);
        return rest === ''
            ? EXTERNAL_API_PREFIX
            : `${EXTERNAL_API_PREFIX}${withLeadingSlash(rest)}`;
    }
    return `${WEB_API_PREFIX}${withLeadingSlash(typed)}`;
}
